import ReqClient from './request.class'
import { MODEL_PRIDICT } from '@/api/config'

// 获取投放数据明细
export async function getPtomPlanData(data) {
  // getModelPredictionResult
  const Req = new ReqClient({
    url: '/api/ptom/plandata/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取投放数据头条起量状态
export async function getPtomPlanToutiaoRaiseStatus(data) {
  const Req = new ReqClient({
    url: '/api/ptom/raise/status/query',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建投放数据头条起量任务
export async function createPtomPlanToutiaoRaiseTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/raise/create',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取投放数据头条起量素材信息
export async function getPtomPlanToutiaoRaiseMaterialInfo(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/raise/info',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取投放数据头条起量任务详情
export async function getPtomPlanToutiaoRaiseDetail(data) {
  const Req = new ReqClient({
    url: '/api/ptom/raise/detail/query',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 停止投放数据头条起量任务详情
export async function ptomPlanToutiaoRaiseTaskStop(data) {
  const Req = new ReqClient({
    url: '/api/ptom/raise/stop',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取投放数据头条起量任务报告
export async function getPtomPlanToutiaoRaiseReport(data) {
  const Req = new ReqClient({
    url: '/api/ptom/raise/report/query',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取游戏回调规则配置
export async function getPtomMiddlewareCallbackConfig(params) {
  const Req = new ReqClient({
    url: '/api/ptom/middleware/callback/config/get',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新游戏回调规则配置
export async function updatePtomMiddlewareCallbackConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/middleware/callback/config/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增腾讯广告创意优投
export async function addPremiumCreativePlan(data) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/materialRaise/gdt/add',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑腾讯广告创意优投
export async function updatePremiumCreativePlan(data) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/materialRaise/gdt/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 腾讯广告创意优投信息获取
export async function getPremiumCreativeAddInfo(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/boost/createInfo',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 腾讯广告创意优投管理信息获取
export async function getPremiumCreativeManageInfo(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/boost/manageInfo',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取投放数据明细预警计划个数
export async function getPtomWarningPlanCounts(params) {
  const Req = new ReqClient({
    url: '/api/ptom/earlywarning/queryEarlyWarningPlanCount',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放明细数据预警规则-分页查询
export async function ptomDetailWarningPlanRuleByPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/earlywarning/query',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放明细数据预警规则-新增
export async function ptomDetailWarningPlanRuleAdd(data) {
  const Req = new ReqClient({
    url: '/api/ptom/earlywarning/add',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放明细数据预警规则-更新
export async function ptomDetailWarningPlanRuleUpdate(data) {
  const Req = new ReqClient({
    url: '/api/ptom/earlywarning/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放明细数据预警规则-删除
export async function ptomDetailWarningPlanRuleDelete(data) {
  const Req = new ReqClient({
    url: '/api/ptom/earlywarning/delete',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放明细数据下载计算记录条数
export async function countPtomPlanData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/countPlanData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放明细数据下载
export async function exportPtomPlanData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/downplandata',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 多素材绑定
export async function bindMultipleMaterials(data) {
  const Req = new ReqClient({
    url: '/api/ptom/muti-material/bind',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号投放明细
export async function getPtomActData(params) {
  const Req = new ReqClient({
    url: '/api/ptom/accountData/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 账号投放明细数据下载
export async function exportPtomActData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/accountData/exportAccountData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取计划模型预测结果
export async function getModelPredictionResult(data) {
  const Req = new ReqClient({
    url: `${MODEL_PRIDICT}/model/getBatchPlanPredictResult`,
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function getThirdAdIdByplanIds(data) {
  const Req = new ReqClient({
    url: '/api/caohua/queryThirdAdIdByplanIds',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function checkBatchTask(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/checkBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询常用查询
export async function getQueryCondition(params) {
  const Req = new ReqClient({
    url: '/api/ptom/queryCondition/list',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 分页常用查询
export async function getQueryConditionByPage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/queryCondition/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function modifyQueryCondition(data) {
  const Req = new ReqClient({
    url: '/api/ptom/queryCondition/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function addQueryCondition(data) {
  const Req = new ReqClient({
    url: '/api/ptom/queryCondition/add',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function delQueryCondition(params) {
  const Req = new ReqClient({
    url: '/api/ptom/queryCondition/delete',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户充值明细
export async function getUserRoleRechargePage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/recharge/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户角色数据
export async function getUserRolePage(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/userInfoPage',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取计划明细数据概览
export async function getPlanDayDetail(params) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/dayDetail',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取计划明细素材数据
export async function getPlanMaterialDetail(params) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/imageDetailData',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量更新广告素材启用状态(目前只支持头条)
export async function materialSwitch(data) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/materialSwitch',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材移除/恢复（腾讯V3、巨量引擎2.0、巨量智擎）op:1-移除,2-恢复
export async function materialRemoveRestore(data) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/materialRemoveRestore',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取计划明细广告位数据
export async function getPlanAdPositionDetail(params) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/querySiteSetReport',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询常用查询
export async function downAdSpiderData(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/downjoblist',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 同步任务管理
export async function getSumData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/getSumData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 新增爬虫监控任务
export async function addAdSpiderJob(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/addtask',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增爬虫监控任务
export async function getTask(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/gettask',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增爬虫监控任务
export async function getFinanceEmailAlert(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/getFinanceEmailAlert',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 批量同步任务月数据
 * @return {*}
 */
// 新增爬虫监控任务
export async function batchMonthSyndata(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/batchMonthSyndata',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询广告信息
export async function queryPlansBymediaId(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/queryPlansBymediaId',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询广告信息
export async function updatetaskplan(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/updatetaskplan',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 同步任务
export async function syndata(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/syndata',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量添加取消白名单
export async function updateWhiteList(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/updateWhiteList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量启用禁用
export async function batchOpenOrClose(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/batchOpenOrClose',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 同步任务管理
export async function getJobList(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/joblist',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 启用禁用
export async function openorclose(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/openorclose',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 启用禁用
export async function financeEmailAlertSet(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/financeEmailAlertSet',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 爬虫任务联调测试
export async function spiderJobConnectTest(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/connecttest',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户充值分布饼图
export async function getPlanDataEvaluatePip(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/getplandataevaluatepip',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户角色等级分布饼图
export async function getRoleLevelDataEvaluatePip(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/getplandataleveldistribution',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户激活设备饼图
export async function getPlanDataRecongisePip(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/getplandatarecongisepip',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取头条操作日志
export async function getPlanLogInfo(data) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/queryLogInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取计划明细数据概览
export async function getPlanDataEvaluate(params) {
  const Req = new ReqClient({
    url: '/api/ptom/planDataDetail/getplandataevaluate',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑账号简称
export async function adAccountEditBase(data) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/editBase',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 投放明细状态枚举字段
 * @return {*}
 */
export async function getPtomDetailPlanStatus(params) {
  const Req = new ReqClient({
    url: '/api/ptom/media/enum/queryStatusEnumByMediaId',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑账号预算
export async function modifyAccountBudget(data) {
  const Req = new ReqClient({
    url: '/api/ptom/accountData/modifyBudget',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑ROI
export async function modifyRoi(data) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/modifyRoi',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 批量联调/数据同步
 */
export async function batchSyncData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/batchSyncData',
    data,
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 批量联调/数据同步导入账号
 */
export async function taskSyncBatchAddAccounts(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/batchExportSynTask',
    data,
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 同步任务财务转账主体下拉数据列表
 */
export async function getFinanceCompanyList() {
  const Req = new ReqClient({
    url: '/api/ptom/tasksyc/getCompanyEnum',
    method: 'GET'
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 同步任务充值转账功能
 * @param {*} data
 */
export async function financeAccountOrderApply(data) {
  const Req = new ReqClient({
    url: '/api/ptom/accountOrder/financeAccountOrderApply',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据账号ID获取可用转账账号
 * @param {*} params
 */
export async function getValidTransferAccounts(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/getValidTransferAccount',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据账号ID获取转账账号余额
 * @param {*} params
 */
export async function getTransferAccountBalance(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/getAmount',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 添加批量浏览模板
 * @param {*} data
 */
export async function addtemplate(data) {
  const Req = new ReqClient({
    url: '/api/ptom/queryCondition/addtemplate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function savetemplate(data) {
  const Req = new ReqClient({
    url: '/api/ptom/queryCondition/savetemplate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 根据账号ID获取可用转账账号
 * @param {*} params
 */
export async function getAccountById(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/get',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据id获取计划投放时间和日期
export async function getPlanLaunchTimeByIds(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatchModifyLaunchTimeAndDate/queryMediaLaunchTime',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新计划投放时间和日期
export async function updatePlanLaunchDateTime(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatchModifyLaunchTimeAndDate/addBatchTask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 计划投放时间和日期修改失败后重试
export async function retryPlanLaunchDateTime(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatchModifyLaunchTimeAndDate/retrytask',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 通过id获取文案包
export async function getTitleLibsByIds(data) {
  const Req = new ReqClient({
    url: '/api/ptom/titlePackage/get',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 通过id获取落地页包
export async function getLandingPageLibsByIds(data) {
  const Req = new ReqClient({
    url: '/api/ptom/landPackagePackage/get',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 通过id获取落定向包
export async function getTargetingLibsByIds(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomMediaTargeting/get',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// v4.43 获取拒审理由(目前仅头条)
export async function getRejectReason(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/getRejectReason',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function uploadAdvertiserAvatar(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/uploadAdvertiserAvatar',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
